import React, { useState, useEffect } from 'react';
import { Button, Typography, TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import CirclePlusIcon from '@material-ui/icons/AddCircleOutline';
import { css } from '@emotion/core';
import { useRootStore } from '../../../../stores/BridgeProvider';
import {
  StyledForm,
  WideBox,
  FlexDiv,
  ButtonFlex,
  FormRow,
} from '../../../styles/styles';
import Spinner from '../../../util/Spinner';
import {
  formFieldGenerator,
  initialValueGenerator,
} from '../../../util/TemplateUtils';
import { DealTemplateSchema } from '../../../../validation';
import AddField from './AddField';
import UpdateField from './UpdateField';
import RenderPropModal from '../../../dealMapper/common/RenderPropModal';

const DisabledInputStyles = css`
  .MuiFormLabel-root.Mui-disabled {
    color: #757575;
  }
  .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.15);
  }

  :hover {
    .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
      border-color: rgba(0, 0, 0, 0.35);
    }
  }
`;

// // border-color: rgba(0, 0, 0, 0.26) !important;
const TemplatePreview = ({ dealTemplate, updateTemplateJSON }) => {
  const history = useHistory();
  const { authStore } = useRootStore();
  const [selectedField, setSelectedField] = useState({});

  //   const [dealTemplate, setDealTemplate] = useState(templateData);

  if (!dealTemplate) return <Spinner />;
  const { Description, Name, DealTemplateId, TemplateJSON } = dealTemplate;
  const { items } = TemplateJSON;
  const initialValues = initialValueGenerator(items);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={DealTemplateSchema(items)}
      onSubmit={async () => {}}
      render={formikProps => {
        return (
          <FlexDiv>
            <WideBox style={{ minWidth: '700px' }} showoverflow={1}>
              <StyledForm>
                <Typography variant="h4" gutterBottom>
                  Template Preview
                </Typography>
                <Typography
                  variant="p"
                  style={{ paddingTop: '10px', display: 'block' }}
                >
                  Add and customize fields for your template
                </Typography>

                <RenderPropModal
                  containerStyle={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    width: '100%',
                  }}
                  cardDisplay={({ handleClose }) => (
                    <AddField
                      json={TemplateJSON}
                      updateTemplateJSON={updateTemplateJSON}
                      handleClose={handleClose}
                    />
                  )}
                >
                  {({ handleOpen }) => (
                    <Button size="small" disableRipple onClick={handleOpen}>
                      <CirclePlusIcon
                        style={{
                          marginRight: '4px',
                          marginLeft: '-3px',
                        }}
                      />{' '}
                      New Field
                    </Button>
                  )}
                </RenderPropModal>
                <RenderPropModal
                  childContainerStyle={{ width: '100%' }}
                  containerStyle={{ width: '100%' }}
                  cardDisplay={({ handleClose }) => (
                    <UpdateField
                      json={TemplateJSON}
                      updateTemplateJSON={updateTemplateJSON}
                      selectedField={selectedField}
                      setSelectedField={setSelectedField}
                      handleClose={handleClose}
                    />
                  )}
                >
                  {({ handleOpen }) => {
                    const fieldArray = items.map((fieldObj, index) => {
                      const {
                        name,
                        type,
                        required,
                        displayName,
                        enumOptions,
                      } = fieldObj;

                      const fieldProps = {
                        key: name,
                        name,

                        label: (
                          <span>
                            {displayName} ({type})
                          </span>
                        ),
                        disabled: true,
                        margin: 'normal',
                        variant: 'outlined',
                        fullWidth: true,
                        required,
                      };
                      return (
                        <FormRow
                          style={{
                            display: 'inline-block',
                            width: fieldObj.width
                              ? `${fieldObj.width}%`
                              : '100%',
                          }}
                          css={DisabledInputStyles}
                          onClick={() => {
                            setSelectedField({ ...fieldObj, position: index });
                            handleOpen();
                          }}
                        >
                          <TextField
                            {...fieldProps}
                            inputProps={{ style: { cursor: 'pointer' } }}
                            floatingLabelStyle={{
                              color: '#757575 !important',
                            }}
                          />
                        </FormRow>
                      );
                    });
                    return (
                      <div
                        style={{
                          textAlign: 'left',
                          width: '100%',
                        }}
                      >
                        {fieldArray}
                      </div>
                    );
                  }}
                </RenderPropModal>
              </StyledForm>
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default TemplatePreview;
